import integrationService from '../../services/IntegrationService'

const service = integrationService

/**
 * Get provider integration details
 * @param provider - The integration provider name
 * @param requests_new_state - Whether to request new state
 * @param integrationId - The integration ID (default: 'current')
 * @returns Object containing integration status and data
 */
export const getProviderIntegration = async (
  provider: string,
  requests_new_state: boolean = false,
  integrationId: string = 'current',
): Promise<{ isIntegrated: boolean; integrationData: any }> => {
  try {
    const response: any = await service.getProviderIntegration(
      provider,
      integrationId,
      requests_new_state,
    )
    if (response && response.status && response.status === 400) {
      return { isIntegrated: false, integrationData: null }
    } else if (
      response &&
      response.status &&
      response.status.code === 200 &&
      response.data
    ) {
      return { isIntegrated: true, integrationData: response.data }
    }
    return { isIntegrated: false, integrationData: null }
  } catch (error) {
    return { isIntegrated: false, integrationData: null }
  }
}

/**
 * Get all content upload integrations for supported LMS platforms
 * @returns Array of integration objects for canvas, blackboard, desire2learn, and moodle
 */
export const getContentUploadIntegrations = async (): Promise<any[]> => {
  try {
    const { status, data } = await service.getIntegrations(null, 'api')
    if (status === 400) {
      return []
    } else if (status === 200 && data) {
      return data.data.integrations.filter((integration: any) =>
        ['canvas', 'blackboard', 'desire2learn', 'moodle'].includes(
          integration.provider,
        ),
      )
    }
  } catch (error) {
    console.error('Error fetching content upload integrations:', error)
  }
  return []
}

/**
 * Check if any content upload integration exists and update the state
 * @param props - Object containing setIsCanvasIntegrated and isCanvasIntegrated
 */
export const checkIntegration = async (props: {
  setIsCanvasIntegrated: (value: any) => void
  isCanvasIntegrated: any
}): Promise<void> => {
  try {
    const integrations = await getContentUploadIntegrations()

    if (integrations.length > 0) {
      props.setIsCanvasIntegrated({
        ...props.isCanvasIntegrated,
        intregate: true,
        data: null,
      })
      return
    }
  } catch (error) {
    console.error('Error checking integration:', error)
  }

  props.setIsCanvasIntegrated({
    intregate: false,
    data: null,
    show: false,
  })
}
